import ClipboardJS from 'clipboard';

/* Add copy/paste support to all buttons with class .btn-clipboard */
new ClipboardJS('.btn-copypasta');
